<template>
    <div class="revision-process">
      
        <ul class="title" v-if="model.processType==='TWO'">
            <li 
                v-for="(item,index) in ljdList"
                :key="index"
                :class="{'active':processType==item.type}"
                @click="titleClick(item.type)">
                    {{item.name}}
            </li>
        </ul>
        <ul class="title" v-if="model.processType==='ZGYS'">
            <li 
                v-for="(item,index) in zgysList"
                :key="index"
                :class="{'active':processType==item.type}"
                @click="titleClick(item.type)">
                    {{item.name}}
            </li>
        </ul>

        <div class="con main" v-if="processType=='one'">
             <el-container>
                <el-main>
                    <p style="margin-bottom:15px">招标流程</p>
                    <el-timeline>
                        <template v-for="(item,index) in oneNodeList">
                            <el-row class="oneElrow" v-if="item.child.length>0" :key="index">
                                <el-col :span="7" style="text-align:right" >
                                    <span style="color:#ab6bbd;padding-right:10px">{{item.nodename}}</span>
                                </el-col>
                                <el-col :span="17">
                                    <template v-for="(li, indexIn) in item.child">
                                        <el-row v-if="li.nodetype=='3'||li.nodetype=='5'" :key="indexIn">
                                            <el-col :span="20">
                                                <el-timeline-item
                                                    v-if="li.izdata"
                                                    type="primary"
                                                    size="large">
                                                        <el-link 
                                                            :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                                <el-timeline-item
                                                    v-if="!li.izdata"
                                                    size="large">
                                                        <el-link 
                                                            :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                            </el-col>
                                            <!--<el-col :span="4">
                                                
                                                <i 
                                                    v-if="li.addurl"
                                                    style="color:#ab6bbd;font-size:16px;cursor: pointer;" 
                                                    class="el-icon-circle-plus"
                                                    @click="$emit('nodeAdd',li)">
                                                </i>
                                            </el-col>-->
                                        </el-row>
                                        
                                    </template>
                                   
                                </el-col>
                            </el-row>
                        </template>
                    </el-timeline>
                </el-main>
             </el-container>
        </div>
        <div class="con main" v-if="processType=='two'">
            <el-container>
                <el-main>
                    <p style="margin-bottom:15px">主要流程</p>
                    <el-timeline>
                        <template v-for="(item,index) in twoNodeList">
                            <el-row class="mainElrow" v-if="item.child.length>0" :key="index">
                                <el-col :span="7" style="text-align:right">
                                    <span style="color:#ab6bbd;padding-right:10px">{{item.nodename}}</span>
                                </el-col>
                                <el-col :span="17">
                                    <template v-for="(li, indexIn) in item.child">
                                        <el-row v-if="li.nodetype=='1'||li.nodetype=='6'" :key="indexIn">
                                            <el-col :span="20">
                                                <el-timeline-item
                                                    v-if="li.izdata"
                                                    type="primary"
                                                    size="large">
                                                        <el-link 
                                                            :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                                <el-timeline-item
                                                    v-if="!li.izdata"
                                                    size="large">
                                                        <el-link 
                                                            :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                            @click="nodeclick(li)"
                                                            :underline="false">
                                                                {{li.nodename}}
                                                        </el-link>
                                                </el-timeline-item>
                                            </el-col>
                                            <el-col :span="4">
                                                <!--<i 
                                                    v-if="li.addurl"
                                                    style="color:#ab6bbd;font-size:16px;cursor: pointer;" 
                                                    class="el-icon-circle-plus"
                                                    @click="$emit('nodeAdd',li)">
                                                </i>-->
                                            </el-col>
                                        </el-row>
                                        
                                    </template>
                                   
                                </el-col>
                            </el-row>
                        </template>
                    </el-timeline>
                </el-main>
             </el-container>
           
        </div>
        <div class="con main">
            <el-container>
                <el-main>
                    <p style="margin-bottom:15px">附加流程</p>
                    <el-timeline>
                        <template v-for="(item,index) in subNodeList">
                            <el-row class="subElrow" v-if="item.child.length>0" :key="index">
                                <el-col :span="7" style="text-align:right">
                                    <span style="color:#ab6bbd;padding-right:10px">{{item.nodename}}</span>
                                </el-col>
                                <el-col :span="17">
                                    <template v-for="(li, indexIn) in item.child">
                                        <el-timeline-item
                                            v-if="li.nodetype=='2'&&li.izdata"
                                            type="primary"
                                            :key="indexIn"
                                            size="large">
                                                <el-link 
                                                    :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                    @click="nodeclick(li)"
                                                    :underline="false">
                                                        <el-badge 
                                                            is-dot 
                                                            v-if="(li.nodecode=='B07001'&&isInfo.izTbCqWt)||(li.nodecode=='E07001'&&isInfo.izZjCqWt)||(li.nodecode=='F11001'&&isInfo.izZbYyTs)"
                                                            class="item">
                                                                {{li.nodename}}
                                                        </el-badge>
                                                        <span v-else>{{li.nodename}}</span>
                                                </el-link>
                                        </el-timeline-item>
                                        <el-timeline-item
                                            :key="indexIn"
                                            v-if="li.nodetype=='2'&&!li.izdata"
                                            size="large">
                                                <el-link 
                                                    :class="{'nodeactive':(clickpath==li.nodeurl+li.nodename||(li.nodeurl+li.nodename).indexOf(clickpath) != -1)}"
                                                    @click="nodeclick(li)"
                                                    :underline="false">
                                                        <el-badge 
                                                            is-dot 
                                                            v-if="(li.nodecode=='B07001'&&isInfo.izTbCqWt)||(li.nodecode=='E07001'&&isInfo.izZjCqWt)||(li.nodecode=='F11001'&&isInfo.izZbYyTs)"
                                                            class="item">
                                                                {{li.nodename}}
                                                        </el-badge>
                                                        <span v-else>{{li.nodename}}</span>
                                                </el-link>
                                        </el-timeline-item>
                                    </template>
                                </el-col>
                            </el-row>
                        </template>
                        
                    </el-timeline>
                </el-main>
            </el-container>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        },
        isInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            processType:'one',
            ljdList:[
                { type: 'one', name:'一阶段' },
                { type: 'two', name:'两阶段' },
            ],
            zgysList:[
                { type: 'one', name:'资格预审流程' },
                { type: 'two', name:'主要流程' },
            ],
            oneNodeList:[],
            twoNodeList:[],
            subNodeList:[],
            clickpath:'',
        }
    },
    watch: {
        
    },
    methods: {
        nodeclick(li){
            this.$emit('nodeClick',li);
            this.clickpath = li.nodeurl+li.nodename;
        },
        titleClick(type){
            this.processType = type;
        },
        init(data){
            var that = this;
            that.oneNodeList = clone(data.nodeList);
            that.twoNodeList = clone(data.nodeList);
            that.subNodeList = clone(data.nodeList);
            data.nodeList.forEach(function(item,index){
                that.oneNodeList[index].child = [];
                that.twoNodeList[index].child = [];
                that.subNodeList[index].child = [];
                item.child.forEach(function(list,i){
                    if(list.nodetype=='3'||list.nodetype=='5'){
                        that.oneNodeList[index].child.push(list)
                    }else if(list.nodetype=='1'||list.nodetype=='6'){
                        that.twoNodeList[index].child.push(list)
                    }else if(list.nodetype=='2'){
                        that.subNodeList[index].child.push(list)
                    }
                })
            })
            console.log(that.oneNodeList)
        },
        processClick(url){
            this.$emit('goFrame',url)
        },
        
    },
    mounted(){
        this.clickpath = '/bidding/projectflow/fangan/biaoduan/list';
    },
}
</script>

<style scoped>
    
    .oneElrow:last-child /deep/ .el-col .el-row:last-child .el-timeline-item .el-timeline-item__tail{ display: none; }
    .mainElrow:last-child /deep/ .el-col .el-row:last-child .el-timeline-item .el-timeline-item__tail{ display: none; }
    .subElrow:last-child /deep/ .el-col .el-timeline-item:last-child .el-timeline-item__tail{ display: none; }
    .title{ text-align: center; }
    .title li{ display: inline-block; padding: 15px 10px 10px; cursor: pointer; margin-right: 20px; font-size: 14px; }
    .active{ border-bottom: 2px solid #3998fc; }
    
</style>